import { render, staticRenderFns } from "./UserSettingsMail.vue?vue&type=template&id=101bb112&"
import script from "./UserSettingsMail.vue?vue&type=script&lang=js&"
export * from "./UserSettingsMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports